import CAHA1230RequestModel from '@/api/data/CAH/CAHA1230/CAHA1230RequestModel'
import CAHA1230ResponseModel from '@/api/data/CAH/CAHA1230/CAHA1230ResponseModel'

import RestService from '@/common/RestService'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import ValidationUtil from '@/common/utils/ValidationUtil'
import CommonUtil from '@/common/utils/CommonUtil'
import Store from '@/common/utils/Store'

export default class CAHG1230Service {
  /**
   * 将来受取額シミュレーション計算結果取得リクエストモデル
   */
  private caha1230RequestModel = new CAHA1230RequestModel()
  /**
   * CAHA1230 API処理呼出
   * @param reservedAmount
   * @param accumulatedBalance
   * @param operationPeriod
   * @param investmentYield
   * @returns response model
   */

  /**
   * 将来受取額シミュレーション計算結果取得呼び出し（非同期処理）
   */
  public async callAPICAHA1230(
    reservedAmount: string,
    accumulatedBalance: string,
    operationPeriod: string,
    investmentYield: string
  ): Promise<CAHA1230ResponseModel> {
    this.caha1230RequestModel.reservedAmount = reservedAmount
    this.caha1230RequestModel.accumulatedBalance = accumulatedBalance
    this.caha1230RequestModel.operationPeriod = operationPeriod
    this.caha1230RequestModel.investmentYield = investmentYield

    const caha1230ResponseModel: CAHA1230ResponseModel = <
      CAHA1230ResponseModel
    > await RestService.post(
      CommonUtil.getApiUrl(ApiUrlConstants.CAHA1230),
      this.caha1230RequestModel
    )
    return caha1230ResponseModel
  }

  /**
   * 入力項目バリデーション
  * @param reservedAmount
   * @param accumulatedBalance
   * @param operationPeriod
   * @param investmentYield
   * @returns isValid boolean
   */

  /* 入力項目チェック処理 */
  public validationInput(
    reservedAmount: string,
    accumulatedBalance: string,
    operationPeriod: string,
    investmentYield: string
  ) {
    /* エラー格納配列 */
    const errorValid = []

    /* 毎月の積立金額未入力チェック */
    if (ValidationUtil.isNotEmptyValid(reservedAmount) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF001',
        message: CommonUtil.getMessage('MSGCAHG1230WF001', [])
      })
      /* 毎月の積立金額半角数字チェック */
    } else if (ValidationUtil.isHankakuNumValid(reservedAmount) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF002',
        message: CommonUtil.getMessage('MSGCAHG1230WF002', [])
      })
      /* 毎月の積立金額入力範囲チェック */
    } else if (ValidationUtil.isExplValid(1, 99, reservedAmount) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF003',
        message: CommonUtil.getMessage('MSGCAHG1230WF003', [])
      })
    }

    /* 現在の積立金残高未入力チェック */
    if (ValidationUtil.isNotEmptyValid(accumulatedBalance) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF004',
        message: CommonUtil.getMessage('MSGCAHG1230WF004', [])
      })

      /* 現在の積立金残高半角数字チェック */
    } else if (ValidationUtil.isHankakuNumValid(accumulatedBalance) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF005',
        message: CommonUtil.getMessage('MSGCAHG1230WF005', [])
      })

      /* 現在の積立金残高入力範囲チェック */
    } else if (ValidationUtil.isExplValid(0, 99999, accumulatedBalance) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF006',
        message: CommonUtil.getMessage('MSGCAHG1230WF006', [])
      })
    }

    /* 運用期間未入力チェック */
    if (ValidationUtil.isNotEmptyValid(operationPeriod) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF007',
        message: CommonUtil.getMessage('MSGCAHG1230WF007', [])
      })
      /* 運用期間半角数字チェック */
    } else if (ValidationUtil.isHankakuNumValid(operationPeriod) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF008',
        message: CommonUtil.getMessage('MSGCAHG1230WF008', [])
      })
      /* 運用期間入力範囲チェック */
    } else if (ValidationUtil.isExplValid(1, 55, operationPeriod) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF009',
        message: CommonUtil.getMessage('MSGCAHG1230WF009', [])
      })
    }

    /* 運用利回り未入力チェック */
    if (ValidationUtil.isNotEmptyValid(investmentYield) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF010',
        message: CommonUtil.getMessage('MSGCAHG1230WF010', [])
      })
      /* 運用利回り半角数字チェック */
    } else if (ValidationUtil.isNumberValid(investmentYield) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF011',
        message: CommonUtil.getMessage('MSGCAHG1230WF011', [])
      })
      /* 運用利回り入力範囲チェック */
    } else if (ValidationUtil.isExplValid(0.00, 20.00, investmentYield) === false) {
      errorValid.push({
        code: 'MSGCAHG1230WF012',
        message: CommonUtil.getMessage('MSGCAHG1230WF012', [])
      })
    }
    return errorValid
  }
}
